// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/infobox.less
// module id = 107
// module chunks = 0